<div class="h-screen bg-gray-50 grid grid-rows-[auto_1fr] overflow-hidden">
  <!-- Banner Component -->
  <app-auth-banner />

  <div class="h-full w-full flex items-center justify-center">
    <div class="w-full max-w-md">
      <!-- Loading Skeleton -->
      @if (!isComponentReady()) {
      <sb-loading-skeleton type="register" />
      } @else {
      <!-- Actual Content with Animation -->
      <div class="animate-slideInUp flex flex-col gap-y-4">
        <div class="flex flex-col gap-y-4">
          <app-register-header />

          <div class="flex flex-col justify-center items-center gap-y-1">
            <div class="flex flex-col gap-y-2">
              <h2 class="text-center text-3xl font-extrabold text-gray-700">
                Sign up
              </h2>
            </div>
          </div>
        </div>

        @if (registrationSuccess()) {
        <div class="animate-slideInUp" style="animation-delay: 200ms">
          <app-registration-success-pane (goToLogin)="goToLogin()" />
        </div>
        } @else {
        <form class="mt-8 space-y-6" (ngSubmit)="onSubmit()" #form="ngForm">
          <!-- Error Alert -->
          <lib-error-alert [error]="authStore.error()" />

          <div class="flex flex-col gap-y-4">
            <!-- First Name and Last Name -->
            <div
              class="grid grid-cols-2 gap-4 animate-slideInLeft"
              style="animation-delay: 100ms"
            >
              <sb-text-input
                id="first_name"
                name="first_name"
                label="First Name"
                type="text"
                autocomplete="given-name"
                [required]="true"
                [(ngModel)]="formData().first_name"
                (inputBlur)="validateField('first_name')"
                [errorMessage]="formErrors()['first_name']"
                placeholder="First name"
              />

              <sb-text-input
                id="last_name"
                name="last_name"
                label="Last Name"
                type="text"
                autocomplete="family-name"
                [required]="true"
                [(ngModel)]="formData().last_name"
                (inputBlur)="validateField('last_name')"
                [errorMessage]="formErrors()['last_name']"
                placeholder="Last name"
              />
            </div>

            <!-- Email -->
            <div class="animate-slideInLeft" style="animation-delay: 200ms">
              <sb-text-input
                id="email"
                name="email"
                label="Email Address"
                type="email"
                autocomplete="email"
                [required]="true"
                [(ngModel)]="formData().email"
                (inputBlur)="validateField('email')"
                [errorMessage]="formErrors()['email']"
                placeholder="Email address"
              />
            </div>

            <!-- Username (Optional) -->
            <div class="animate-slideInLeft" style="animation-delay: 300ms">
              <sb-text-input
                id="username"
                name="username"
                label="Username (Optional)"
                type="text"
                autocomplete="username"
                [(ngModel)]="formData().username"
                (inputBlur)="validateField('username')"
                [errorMessage]="formErrors()['username']"
                placeholder="Choose a username"
              />
            </div>

            <!-- Password -->
            <div class="animate-slideInLeft" style="animation-delay: 400ms">
              <sb-text-input
                id="password"
                name="password"
                label="Password"
                type="password"
                autocomplete="new-password"
                [required]="true"
                [(ngModel)]="formData().password"
                (inputBlur)="validateField('password')"
                [errorMessage]="formErrors()['password']"
                placeholder="Password (minimum 8 characters)"
              />
            </div>

            <!-- Confirm Password -->
            <div class="animate-slideInLeft" style="animation-delay: 500ms">
              <sb-text-input
                id="confirm_password"
                name="confirm_password"
                label="Confirm Password"
                type="password"
                autocomplete="new-password"
                [required]="true"
                [(ngModel)]="formData().confirm_password"
                (inputBlur)="validateField('confirm_password')"
                [errorMessage]="formErrors()['confirm_password']"
                placeholder="Confirm your password"
              />
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="animate-slideInUp" style="animation-delay: 600ms">
              <app-submit-signup-button
                text="Sign up"
                loadingText="Signing up..."
                [isLoading]="authStore.isLoading()"
                [disabled]="!isFormValid()"
                (submitClick)="onSubmit()"
              />
            </div>

            <div
              class="text-sm text-center text-gray-500 animate-slideInUp"
              style="animation-delay: 700ms"
            >
              Already have an account?
              <a
                routerLink="/login"
                class="font-medium text-orange-400 hover:text-orange-300 transition-colors duration-200"
              >
                Sign in
              </a>
            </div>
          </div>
        </form>
        }
      </div>
      }
    </div>
  </div>
</div>
